import { createI18Instance, globalConfig, RuntimeProvider } from "config";
import React from "react";
import ReactDOM from "react-dom/client";
import { I18nextProvider } from "react-i18next";
import { BrowserRouter } from "react-router-dom";
import {
	type CookieConsentChoice,
	disableGoogleAnalytics,
	hasAnalyticsConsent,
	initGoogleAnalytics,
	onCookieConsentChange
} from "utilities";

import App from "./App";
import "./index.css";

// GA4 is non-essential, so it waits for the visitor's Accept on the cookie banner (TTAPI-47). Returning
// visitors who already accepted get it before the first render, so their landing view is not missed.
// A no-op when no measurement id is configured — no script request, nothing written to the device.
if (hasAnalyticsConsent()) {
	initGoogleAnalytics(globalConfig.ga4MeasurementId);
}

onCookieConsentChange((choice: CookieConsentChoice) =>
	choice === "granted"
		? initGoogleAnalytics(globalConfig.ga4MeasurementId)
		: disableGoogleAnalytics(globalConfig.ga4MeasurementId)
);

const { i18n } = createI18Instance(globalConfig.publicPath, {
	currentLocale: globalConfig.i18n.defaultLocale,
	timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Asia/Calcutta",
	i18n: globalConfig.i18n
});

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
	<React.StrictMode>
		<BrowserRouter>
			<I18nextProvider i18n={i18n}>
				<RuntimeProvider runtime={globalConfig}>
					<App />
				</RuntimeProvider>
			</I18nextProvider>
		</BrowserRouter>
	</React.StrictMode>
);
